/**
 * @generated SignedSource<<20a6f51f522d15758d6a81ed1c455dfa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type async_softwareReleasesVersionDetail_AsyncEditableName$data = {
  readonly name: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"editableName_softwareReleasesVersionDetail">;
  readonly " $fragmentType": "async_softwareReleasesVersionDetail_AsyncEditableName";
};
export type async_softwareReleasesVersionDetail_AsyncEditableName$key = {
  readonly " $data"?: async_softwareReleasesVersionDetail_AsyncEditableName$data;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesVersionDetail_AsyncEditableName">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "async_softwareReleasesVersionDetail_AsyncEditableName",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "FragmentSpread",
      "name": "editableName_softwareReleasesVersionDetail"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "72635c9ff5ceeb9dc0fc3b0d03ba28e8";

export default node;
